<template>
    <div class="Management_group">
        <!-- <el-row :gutter="20">
        <el-col :span="24">-->
        <Main></Main>
        <!-- </el-col>
        </el-row>-->
    </div>
</template>
<script>
import Main from "./management_group/Main.vue";
export default {
    name: "Management_group",
    data() {
        return {};
    },
    components: {
        Main,
    },
};
</script>
<style>
.Management_group {
    /* background: #fff; */
}
</style>